// dataContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [sedacky, setSedacky] = useState([]);
  const [nabytok, setNabytok] = useState([]);
  const [latky, setLatky] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [sedackyData, nabytokData, latkyData] = await Promise.all([
          fetch('https://intercms.vercel.app/api/sedacky').then(res => res.json()),
          fetch('https://intercms.vercel.app/api/nabytok').then(res => res.json()),
          fetch('https://intercms.vercel.app/api/latky').then(res => res.json()),
        ]);
        setSedacky(sedackyData);
        setNabytok(nabytokData);
        setLatky(latkyData);
      } catch (err) {
        setError('Failed to fetch data.');
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <DataContext.Provider value={{ sedacky, nabytok, latky, loading, error }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
